<template>
  <div class="error">
    <div class="error-tip">
      <div class="error-tip-text1">请在标记有</div>
      <div class="error-tip-icon"></div>
      <div class="error-tip-text2">
        的商家使用
      </div>
    </div>
    <div :class="['error-body', errorMsg ? 'isError' : '']">
      <template v-if="errorMsg">
        <div class="error-body-err-icon"></div>
        <div class="error-body-err-text">
          {{ errorMsg.split(',')[0] || '账户异常' }}
        </div>
        <div class="error-body-err-hint">
          {{ errorMsg.split(',')[1] || '请联系客服' }}
        </div>
      </template>
      <template v-else>
        <div class="error-body-offline-img"></div>
        <div class="error-body-offline-title">
          无法连接到网络
        </div>
        <div class="error-body-offline-subtitle">
          请检查网络设置或稍后再试
        </div>
        <div class="error-body-offline-button" @click="$emit('getUserQRCode')">
          <div class="error-body-offline-button-text">
            重试
          </div>
        </div>
      </template>
    </div>
  </div>
</template>
<script>
import { getUrlParam } from '@mx/acquiring-utils';

export default {
  name: 'ErrorPage',
  props: {
    failCode: {
      type: Number,
      default: 100000,
    },
    errorMsg: {
      type: String,
      default: '',
    },
  },
  data() {
    return {}
  },
  computed: {
    status() {
      return getUrlParam('type') === 'scan' ? 2 : 1
    },
  },
  mounted() {
    this.$lx.errorPagePV({ custom: { status: this.status } })
    this.$lx.errorStatusMV({
      fail_code: this.failCode,
      status: this.status,
    })
  },
}
</script>
<style lang="less">
@import '../assets/variable.less';
.error {
  .size(100%);
  padding: 18px 15px 15px;
  .flex-column-center();
  &-tip {
    .flex-center(center);
    .font-area(12px);
    font-family: PingFangSC-Regular;
    color: rgba(0, 0, 0, 0.7);
    &-text1 {
      margin-right: 4px;
    }
    &-icon {
      height: 10px;
      width: 16px;
      .bg-img(
        url(data:image/png;base64,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)
      );
    }
    &-text2 {
      margin-left: 3px;
    }
  }
  &-body {
    .flex-column-center();
    margin-top: 10px;
    width: 345px;
    height: 100%;
    background: #ffffff;
    border-radius: 9px;
    &-offline {
      &-img {
        margin-top: 137px;
        .size(150px);
        .bg-img(url('../assets/img/error.png'));
      }
      &-title {
        margin-top: 15px;
        .font-area(16px);
        opacity: 0.9;
        font-family: PingFangSC-Medium;
        color: #000000;
        text-align: center;
      }
      &-subtitle {
        margin-top: 9px;
        .font-area(14px);
        opacity: 0.5;
        font-family: PingFangSC-Regular;
        color: #000000;
        text-align: center;
      }
      &-button {
        .flex-center(center);
        margin-top: 30px;
        height: 37px;
        width: 76px;
        background: #ffd100;
        border-radius: 6px;
        &-text {
          opacity: 0.7;
          font-family: PingFangSC-Semibold;
          font-size: 13px;
          color: #000000;
          text-align: center;
          line-height: 18px;
        }
      }
    }
    &-err {
      &-icon {
        margin-top: 120px;
        .bg-img(
          url(data:image/png;base64,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)
        );
        .size(46px);
      }
      &-text {
        margin-top: 24px;
        font-family: PingFangSC-Regular;
        font-size: 20px;
        color: #222222;
        letter-spacing: 0;
        text-align: center;
        line-height: 28px;
      }
      &-hint {
        margin-top: 6px;
        opacity: 0.5;
        font-family: PingFangSC-Regular;
        font-size: 14px;
        color: #222222;
        line-height: 20px;
      }
    }
  }
}
.isError {
  margin-bottom: 161px;
}
</style>
